<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <div class="div_loading">
            <div class="my-container" [hidden]="!loading">
                <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
            </div>
        </div>
        <span>
            <span>ویرایش</span>
        </span>
        <span (click)="close()">
            <mat-icon class="close">close</mat-icon>
        </span>
    </div>
</div>

<form [formGroup]="form1" (ngSubmit)="check_access(type_task)">
    <div mat-dialog-content class="matDialogContent" style="padding:0px !important;max-height:91vh;overflow-y: hidden;">
        <div class="row pe1">
            <textarea class="wh-input" style="width:100%;max-height:100vh;height:91vh" formControlName="comment">

          </textarea>
        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <button type="submit" class="btn_pe">
            <span>ذخیره</span>
        </button>
    </div>
</form>